module.exports = __webpack_public_path__ + "img/03-01_Managing under performance.57800ff5.svg";